import ClientLogo from "@/components/common/ClientLogo";
import PrimaryButton from "@/components/common/PrimaryButton";
import Layout from "@/components/layout/Layout";
import Benefits from "@/components/services/common/Benefits";
import BigImageSection from "@/components/services/common/BigImageSection";
import ServiceFaqs from "@/components/services/common/ServiceFaqs";
import ServicesHeader from "@/components/services/common/ServicesHeader";
import OurStaff from "@/components/services/it-staff-augmentation-services/OurStaff";
import WhatIsStaffAugmentation from "@/components/services/it-staff-augmentation-services/WhatIsStaffAugmentation";
import WorkProcess from "@/components/services/it-staff-augmentation-services/WorkProcess";
import { LINK_OF_ALL_PAGES } from "const/common";
import {
  STAFF_AUGMENTATION_DETAIL,
  STAFF_AUGMENTATION_FAQS_DATA,
  STAFF_AUGMENTATION_SCHEMA,
  STAFF_AUGMENTATION_TITLE,
  STAFF_AUGMENTATION_URL,
  WHAT_EXPECT_IT_STAFF_DATA,
} from "const/services/it-staff-augmentation-services";

const StaffAugmentation = () => {
  return (
    <Layout
      canonicalLink={STAFF_AUGMENTATION_URL}
      description={STAFF_AUGMENTATION_DETAIL}
      keywords={
        "staff augmentation companies IT Staff Augmentation   IT Staff Augmentation Service  IT staff augmentation companies staff augmentation company  IT staff augmentation company staff augmentation companies in usa  IT staff augmentation company in usa"
      }
      ogDescription={STAFF_AUGMENTATION_DETAIL}
      ogImage={
        "https://ultroneous.com/assets/services/staff-augmentation/it-staff-og.webp"
      }
      ogTitle={STAFF_AUGMENTATION_TITLE}
      ogType={"IT Staff Augmentation Service"}
      ogUrl={STAFF_AUGMENTATION_URL}
      schema={{ ...STAFF_AUGMENTATION_SCHEMA }}
      title={STAFF_AUGMENTATION_TITLE}
      twitterDescription={STAFF_AUGMENTATION_DETAIL}
      twitterImage={
        "https://ultroneous.com/assets/services/staff-augmentation/it-staff-og.webp"
      }
      twitterTitle={STAFF_AUGMENTATION_TITLE}
    >
      <ServicesHeader
        details="Extend your project team with <strong>IT staff augmentation service</strong> from ultroNeous. Work directly with our trained designers, developers and other IT staff members."
        heading="IT staff augmentation service"
        pageName="Staff Augmentation"
      />
      <BigImageSection
        alt="IT staff augmentation service"
        details="Being a reputable IT staff augmentation company, we help startups, technology companies, marketplaces and all kinds of businesses to expand their remote teams. Be it a UI/ UX designer or a full stack & <a href='https://ultroneous.com/mobile-application-development-services'>  mobile app developer</a>; our recruitment process picks the best people of the industry. They are getting trained following the advanced technology frameworks and tools to keep themselves updated with the latest trends. When you leverage our IT staff augmentation services, we understand your exact needs and supply the dedicated resources who can work directly with you as well as your clients as required to boost up the product development speed."
        link={LINK_OF_ALL_PAGES.mainPages.contactUs}
        src="/assets/services/staff-augmentation/staff-augmentation.webp"
        title="IT staff augmentation service"
        val="Talk to an expert"
      />
      <WhatIsStaffAugmentation />
      <WorkProcess />
      <OurStaff />
      <div className="py-8 md:py-16 bg-primary-black">
        <ClientLogo />
      </div>
      <div className="md:py-24">
        <Benefits data={WHAT_EXPECT_IT_STAFF_DATA} title="What you can expect" />
        <div className="flex justify-center pb-16">
          <PrimaryButton
            link={LINK_OF_ALL_PAGES.mainPages.contactUs}
            val="Let’s start now"
          />
        </div>
      </div>
      <ServiceFaqs data={STAFF_AUGMENTATION_FAQS_DATA} />
    </Layout>
  );
};

export default StaffAugmentation;
